import React from "react";

import Typography from '@mui/material/Typography';

import vaporizerON  from "../images/water_boiler_fail.svg";
import vaporizerOFF  from "../images/water_boiler_not_fail.svg";

import Stack from '@mui/material/Stack';

function Disabled({ disabled, children }) {
  if (disabled) {
    return (
      <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
        {children}
      </div>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
}

const Vaporizer = ({ id, value, title, desc, disabled }) => {
    if(value === "true")
    {
        return (
          <Disabled disabled={disabled}>
            <Stack direction="column" align="left">
            <img
                      src={vaporizerON}
                      alt={title}
                      loading="lazy"
                      style={
                        {
                          width: 120,
                          height: '100%',
                        }
                      }
                    />
                    <Typography variant="caption" gutterBottom component="div">
                    {desc}
                  </Typography>
                  <Typography style={{marginBottom: 53}} variant="subtitle2" gutterBottom component="div">
                    FAIL
                  </Typography>
            </Stack>
            </Disabled>
          );
    }
    else
    {
        return (
          <Disabled disabled={disabled}>
            <Stack direction="column" align="left">
            <img
                      src={vaporizerOFF}
                      alt={title}
                      loading="lazy"
                      style={
                        {
                          width: 120,
                          height: '100%',
                        }
                      }
                    />
                    <Typography variant="caption" gutterBottom component="div">
                    {desc}
                  </Typography>
                  <Typography style={{marginBottom: 53}} variant="subtitle2" gutterBottom component="div">
                    NOT FAIL
                  </Typography>
            </Stack>
            </Disabled>
          );
    }
  
};

export default Vaporizer;
